import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import DTNAPPFeatures from "./DTNAPPFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import APPBenefit from "../APPBenefits/APPBenefit";

// Main component for DTN APP
export default function DTNAPP() {
  // Overview data sections
  const data1 = [
    "Hyper-local Supply Chain Orchestration: Ensures precise coordination and efficiency in agricultural logistics at the local level.",
    "Contract Farming Services: Integrates contract farming for streamlined agricultural operations.",
    "Contract Manufacturing Services: Optimizes production and supply chain management through contract manufacturing.",
  ];

  const data2 = [
    "Storage Service: Provides efficient storage management for agricultural inventory.",
    "Transportation Service: Facilitates seamless logistics in agricultural supply chains.",
  ];

  return (
    <>
      {/* Banner section */}
      <UpdatesBanner
        DlBtn="true"
        className="sdh-bg"
        bannerTitle={["DTN APP"]}
        DownloadText="Download App"
        dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.aamcapp&hl=en&gl=US"
      />

      {/*  Overview */}
      <SolutionEcosystem title="Overview" type="DTN" />

      {/*  Overview Feature*/}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/*  Features & Benefits Section */}
      <DTNAPPFeatures />
      <APPBenefit />
    </>
  );
}
